export const GetBkgHeader = (uri) => {
    let bkgHeader = 'default-header';
    /* univers */
    if (uri.match(/univers/)) {
        if (uri.match(/adventure-way/)) bkgHeader = 'adventure-way';
        if (uri.match(/adventureland/)) bkgHeader = 'adventureland';
        if (uri.match(/discoveryland/)) bkgHeader = 'discoveryland';
        if (uri.match(/fantasyland/)) bkgHeader = 'fantasyland';
        if (uri.match(/frontierland/)) bkgHeader = 'frontierland';
        if (uri.match(/main-street-usa/)) bkgHeader = 'main-street-usa';
        if (uri.match(/avengers-campus/)) bkgHeader = 'avengers-campus';
        if (uri.match(/world-premiere-plaza/)) bkgHeader = 'world-premiere-plaza';
        if (uri.match(/world-of-frozen/)) bkgHeader = 'world-of-frozen';
        if (uri.match(/worlds-of-pixar/)) bkgHeader = 'worlds-of-pixar';
    }
    /* park */
    if (!uri.match(/univers/)) {
        if (uri.match(/park-disneyland/)) bkgHeader = 'park-disneyland';
        if (uri.match(/disney-adventure-world/)) bkgHeader = 'disney-adventure-world';
    }
    /* others */
    if (uri.match(/experience/)) bkgHeader = 'experiment';
    return bkgHeader;
}